import { render } from "./PlotProjection.vue?vue&type=template&id=03a89fbe"
import script from "./PlotProjection.vue?vue&type=script&lang=js"
export * from "./PlotProjection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__